import { render, staticRenderFns } from "./AccessTokenModal.vue?vue&type=template&id=ff8cbac6"
import script from "./AccessTokenModal.vue?vue&type=script&lang=js"
export * from "./AccessTokenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports